export function makeId() {
  // надёжный fallback для старых WebKit
  try {
    // @ts-ignore
    if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID();
  } catch {}
  const s4 = () =>
    Math.floor((1 + Math.random()) * 0x10000).toString(16).slice(1);
  return `${Date.now().toString(36)}-${s4()}${s4()}-${s4()}-${s4()}`;
}
